import React from 'react';
import { observer } from 'mobx-react';

import { constants } from '../../../config';
import { HomeNavbar } from '../../../common/home-navbar';
import { Footer } from '../../../common/footer';
import { routeNaming, AppLink, AppRedirect } from '../../../routes';
import { SessionStore } from '../../../stores/SessionStore';
import { ScreenStore } from '../../../stores/ScreenStore';
import { CreditAndPaymentStore } from '../../../stores/CreditAndPaymentStore';
import { USER_TYPES } from '../../../models/User';
import { MyAccountMenu } from '../my-account-menu';
import { Table } from '../../../common/table-data';
import { columnsCredit, columnsPayments } from './config';
import { Tabs, TabItem } from './Styled';

import styles from './MyCredit.css';

class MyCredit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      view: 'credit',
    };
    this._onChangeView = this._onChangeView.bind(this);
  }

  componentDidMount() {
    CreditAndPaymentStore.getCredits();
  }

  _onChangeView(view) {
    this.setState({ view });
  }

  render() {
    if (!SessionStore.loggedIn || !SessionStore.user.showCredit) {
      return (
        <AppRedirect routeName={routeNaming.HOME} />
      );
    }

    const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;
    return (
      <div className={styles.container}>
        <HomeNavbar />
        <div className={styles.mainContent}>
          {
            !mobileVersion &&
            <div className={styles.titleContainer}>
              <h1 className={styles.title}>Mi Cuenta</h1>
              <h2 className={styles.subtitle}>
                <span>Hola, </span>
                {SessionStore.user.type === USER_TYPES.COMPANY ?
                  SessionStore.user.fictitiousName :
                  SessionStore.user.names}
                !
              </h2>
            </div>
          }
          {
            mobileVersion &&
            <p className={styles.breadcrumb}>
              <AppLink
                className={styles.breadcrumb}
                routeName={routeNaming.MY_ACCOUNT_MENU_MOBILE}
              >
                Mi Cuenta
              </AppLink>
              <span> &gt; Mis créditos</span>
            </p>
          }
          <div className={styles.content}>
            {
              !mobileVersion && <MyAccountMenu indexSelectedItem={5} />
            }
            <div className={styles.myCreditContainer}>
              <div className={styles.headerContainer}>
                <h2 className={styles.header}>
                  Mis créditos
                </h2>
              </div>
              <Tabs>
                <TabItem active={this.state.view === 'credit'}><button onClick={() => this._onChangeView('credit')}>Créditos</button></TabItem>
                <TabItem active={this.state.view === 'payment'}><button onClick={() => this._onChangeView('payment')}>Pagos</button></TabItem>
              </Tabs>
              {
                this.state.view === 'credit' ?
                  <Table
                    columns={columnsCredit}
                    data={CreditAndPaymentStore.credits || []}
                    nodata="No tiene créditos"
                  /> :
                  <Table
                    columns={columnsPayments}
                    data={CreditAndPaymentStore.payments || []}
                    nodata="No tiene pagos"
                  />
              }
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const ObservableMyOrders = observer(MyCredit);

export { ObservableMyOrders as MyCredit };



// WEBPACK FOOTER //
// ./src/pages/my-account/my-credit/MyCredit.jsx